
module.exports = {

    arabicChar: [
        {
            arVal: '٠',
            enVal: '0'

        },
        {
            arVal: '١',
            enVal: '1'

        },
        {
            arVal: '٢',
            enVal: '2'

        },
        {
            arVal: '٣',
            enVal: '3'

        },
        {
            arVal: '٤',
            enVal: '4'

        }
        , {
            arVal: '٥',
            enVal: '5'

        },
        {
            arVal: '٦',
            enVal: '6'

        },
        {
            arVal: '٧',
            enVal: '7'

        },
        {
            arVal: '٨',
            enVal: '8'

        },
        {
            arVal: '٩',
            enVal: '9'

        },
        {
            arVal: 'هـ',
            enVal: ''

        },

        {
            arVal: '/',
            enVal: '-'

        }
    ]
    ,
    arabicMonths: [
        {
            number: '01',
            name: 'مُحرَّم'
        },
        {
            number: '02',
            name: 'صفَر'
        }
        , {
            number: '03',
            name: 'ربيع الأول'
        }
        , {
            number: '04',
            name:  'ربيع الآخر'
        }
        , {
            number: '05',
            name: 'جمادي الأول'
        }
        , {
            number: '06',
            name: 'جمادي الآخر'
        }
        , {
            number: '07',
            name: 'رَجب'
        }, {
            number: '08',
            name: 'شَعبان'
        }, {
            number: '09',
            name: 'رَمضان'
        }, {
            number: '10',
            name: 'شوّال'
        }, {
            number: '11',
            name: 'ذو القِعدة'
        }, {
            number: '12',
            name: 'ذو الحِجّة'
        }


    ]

}